import { useAppContext } from '@lib/AppContext';
import { hexToRgbArray } from '@src/utils/common';
import { useEffect, useMemo } from 'react';
import type { PowerBranding } from '../graphql/generated';

export function usePageTheme(powerBranding: PowerBranding) {
  const { theme } = useAppContext();
  const setColors = theme?.setColors;

  const colors = useMemo(() => {
    if (powerBranding) {
      return {
        bg: hexToRgbArray(powerBranding.power_branding_color_bg, '#000000'),
        fg: hexToRgbArray(powerBranding.power_branding_color_fg, '#FFFFFF'),
        surface: hexToRgbArray(powerBranding.power_branding_color_surface, '#181818'),
        primary: hexToRgbArray(powerBranding.power_branding_color_primary, '#FF0000'),
      };
    }
    return {};
  }, [powerBranding]);

  useEffect(() => {
    if (colors && setColors) {
      setColors((prevTheme) => ({
        ...prevTheme,
        ...colors,
      }));
    }
  }, [colors, setColors]);
}
